import { DocCategory } from '@/plugins/api'
export default {
  namespaced: true,
  state: {
    docCategories: [],
  },
  actions: {
    async fetchTree({ commit }, data) {
      try {
        const res = await DocCategory.fetchTree(data)
        commit('setDocCategory', res)
        return res
      } catch (error) {
        console.log(error)
      }
    },
  },
  mutations: {
    setDocCategory(state, doc) {
      state.docCategories = doc
    },
  },
}
